/**
 * Entity Type Enum
 * Used to determine the context for tickets component
 */
export enum EntityType {
    COURSE = 'course',
    LEARNER = 'learner',
    NONE = 'none'
}
